module.exports = __webpack_public_path__ + "static/bg-4239ec9e5b5962ab517d6e0a89746462.svg";